import { QrCodeAction } from "../@types/QrCode";

export const actions: Record<QrCodeAction["event"], { displayName: string }> = {
  "open-company-page": { displayName: "Open a company page" },
  "open-device-page": { displayName: "Open a device page" },
};
